import React from 'react';
import styled from '@emotion/styled';
import { Text } from '@qga/roo-ui/components';

import Skeleton from '@shared/v2/components/Skeleton';

import htmlToReact from '@/utils/htmlToReact';

export type DescriptionProps = {
  description: string | undefined;
};

const TruncatedText = styled(Text)`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`;

const Description = ({ description }: DescriptionProps) => {
  return (
    <Skeleton.Paragraph length={3} height="1rem" mt={0}>
      {description ? (
        <TruncatedText
          data-testid="ROOM_DESCRIPTION"
          color="text.body"
          lineHeight="24px"
          fontSize={['xs', null, 'sm']}
        >
          {htmlToReact(description)}
        </TruncatedText>
      ) : null}
    </Skeleton.Paragraph>
  );
};

export default Description;
